<script lang="tsx" setup>
import type { IListenViewModel } from 'core'
import { useRecordingError, useTheme } from './logic'

const { data } = defineProps<{
  data?: IListenViewModel | null
  logo?: string | boolean
}>()

const error = useRecordingError()
const { ThemeScope } = useTheme()
</script>

<template>
  <ThemeScope id="vocal-listen-page-wrapper" class="wrapper" :theme="data?.settings.theme">
    <NuxtLayout v-if="error.hasError || !data" name="basic" :logo>
      <PageListenError />
    </NuxtLayout>

    <NuxtLayout
      v-else name="basic" class="place-items-center size-screen overflow-y-auto"
      header-class="listen-page-header h-48px max-w-screen-lg flex items-center justify-between" :logo
    >
      <template #header>
        <PageListenAction class="lt-sm:hidden" />
      </template>

      <PageListenView />

      <PageListenAction class="sm:hidden" />
    </NuxtLayout>
  </ThemeScope>
</template>
